class AdminDatagridController {
    constructor($http, $window, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = [];
        this.filterCategory = [];

        this.startDate = '';
        this.endDate = '';
    }

    $onInit() {
        this.data = JSON.parse(this.srcData.replace(/'/g, '"'));
        var inArray = false;
        for (var index in this.data) {
            if(this.filterCategory.length > 0) {
                inArray = false;
                for (var i = 0; i < this.filterCategory.length; i++) {
                    if(this.data[index][this.filterSelectProperty] === this.filterCategory[i]) {
                        inArray = true;
                    }
                }
                if(!inArray) {
                    this.filterCategory.push(this.data[index][this.filterSelectProperty]);
                }
            } else {
                this.filterCategory.push(this.data[index][this.filterSelectProperty]);
            }
        }
    }

    dateFilter(startDate, endDate, startOnFilter, endOnFilter) {
        return function(item) {
            var isStart = false;
            var isEnd = false;
            var isBoth = false;
            if(startDate !== '') {
                isStart = true;
            }
            if(endDate !== '') {
                isEnd = true;
            }
            if(isStart && isEnd) {
                isBoth = true;
            }
            if(isBoth) {
                if(new Date(startDate) < new Date(item[startOnFilter]) && new Date(endDate) > new Date(item[endOnFilter])) {
                    return item;
                }
            } else if(isStart) {
                if(new Date(startDate) < new Date(item[startOnFilter])) {
                    return item;
                }
            } else if(isEnd) {
                if(new Date(endDate) > new Date(item[endOnFilter])) {
                    return item;
                }
            } else {
                return item;
            }
        };
    }
}

export default AdminDatagridController;



// WEBPACK FOOTER //
// ./src/app/angular/admin-datagrid/admin-datagrid.controller.js